import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './SpeechToTextControlBar.scss';

class SpeechToTextControlBar extends Component {
	constructor(props) {
		super(props);
		this.currrentPosition = React.createRef();
	}

	setPlayerPositionOnClick = (evt) => {
		const e = evt.target;
		const dim = e.getBoundingClientRect();
		var x = evt.clientX - dim.left;
		const positionDif = evt.currentTarget.offsetWidth - x;
		const position = (positionDif / evt.currentTarget.offsetWidth) * 100;
		this.props.movePlayerToPosition((this.props.videoDuration / 100) * (100 - position));
	};

	setPlayerPositionOnStart = () => {
		this.props.movePlayerToPosition(0);
	};

	formatSrtTime = (millis) => {
		let thours = '00',
			tminutes = '00',
			tseconds = '00',
			tms = '00';
		let hours, minutes, seconds;
		thours += hours = Math.floor(millis / 1000 / 3600);
		tminutes += minutes = Math.floor(millis / 1000 / 60) - hours * 60;
		tseconds += seconds = Math.floor(millis / 1000) - hours * 3600 - minutes * 60;
		tms += Math.floor(millis) - hours * 3600000 - minutes * 60000 - seconds * 1000;
		return (
			thours.substr(thours.length - 2) +
			':' +
			tminutes.substr(tminutes.length - 2) +
			':' +
			tseconds.substr(tseconds.length - 2) +
			':' +
			tms.substr(tms.length - 3)
		);
	};

	render() {
		return (
			<div id="playerCtrl">
				<button id="toStartBtn" onClick={() => this.setPlayerPositionOnStart()} />
				<button
					id="playBtn"
					className={this.props.isPlaying ? 'playBtnPause' : ''}
					onClick={() => this.props.onTogglePlay()}
				/>
				<div className="videoDuration">
					{isNaN(this.props.trimItem.start) ? "00:00:00:00": this.formatSrtTime(this.props.playerPosition * 1000 + this.props.trimItem.start)}{' '}
				</div>
				<div id="progressBar" onClick={(event) => this.setPlayerPositionOnClick(event)} style={{ cursor: "pointer" }}>
					<div
						ref={this.currrentPosition}
						id="progress-current"
						style={{ width: (this.props.playerPosition/this.props.videoDuration) * 100 + '%' }}
					></div>
				</div>
				<div className="videoDuration">
					{this.props.trimItem.exists
						? this.formatSrtTime(this.props.trimItem.end)
						: this.formatSrtTime(this.props.videoDuration * 1000)}{' '}
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ interactTimelineReducer }) => ({
	interactItems: interactTimelineReducer.items,
});

const mapDispatchToProps = () => ({
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(SpeechToTextControlBar);
